import { Types } from "@citychallenge/common";

import {
  registerDecorator,
  ValidationOptions,
  ValidationArguments,
} from "class-validator";

export function IsValidMarkdown(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: "isValidMarkdown",
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(
          value: Types["MarkdownText"] | undefined,
          _args: ValidationArguments
        ) {
          if (value?.text?.length) return true;
          return false;
        },
      },
    });
  };
}
